import { useMemo } from "react";

/* Ícones outline, sem preenchimento e sem bloco */
function IconMapPin({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 22s7-6 7-12a7 7 0 1 0-14 0c0 6 7 12 7 12Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}
function IconPhone({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M22 16.9v2a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 3.2 4.1 2 2 0 0 1 5.2 2h2a2 2 0 0 1 2 1.7c.1.9.3 1.8.7 2.6.2.6 0 1.3-.4 1.8l-1 1a16 16 0 0 0 6 6l1-1c.5-.5 1.2-.7 1.8-.4.8.3 1.7.5 2.6.7A2 2 0 0 1 22 16.9Z" />
    </svg>
  );
}
function IconMail({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />
      <path d="m22 8-10 7L2 8" />
    </svg>
  );
}
function IconInsta({ className = "h-5 w-5" }) {
  // versão outline (stroke), sem fill branco
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" />
      <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
    </svg>
  );
}
function IconLinkedIn({ className = "h-5 w-5" }) {
  // outline clean
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="2" y="2" width="20" height="20" rx="3" />
      <line x1="7" y1="10" x2="7" y2="17" />
      <line x1="7" y1="7" x2="7" y2="7" />
      <path d="M12 17v-4a3 3 0 0 1 6 0v4" />
    </svg>
  );
}
function IconX({ className = "h-5 w-5" }) {
  // outline X (twitter)
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 4l16 16M20 4L4 20" />
    </svg>
  );
}
function IconArrowUp({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  );
}

/* Dados do contato */
const WHATS_E164 = "554137979092"; // +55 41 3797-9092
const WHATS_HUMAN = "+55 41 3797-9092";
const EMAIL = "gislaine.curvelo@loviz.com.vc";
const ADDRESS = "Av. Sete de Setembro, 4476 — Batel, Curitiba • PR";
const WHATS_TEXT = "Olá! Quero falar com vendas da LOViZ.";

export default function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);
  const waLink = useMemo(
    () => `https://wa.me/${WHATS_E164}?text=${encodeURIComponent(WHATS_TEXT)}`,
    []
  );

  return (
    <footer className="relative overflow-hidden">
      {/* fundo sutil */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div
          className="absolute -left-24 top-0 h-[18rem] w-[18rem] rounded-full blur-3xl opacity-[.12]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,0,100,.45) 0%, rgba(255,0,100,0) 60%)" }}
        />
        <div
          className="absolute right-[-8rem] bottom-[-8rem] h-[22rem] w-[22rem] rounded-full blur-3xl opacity-[.10]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,77,145,.35) 0%, rgba(255,77,145,0) 60%)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/40 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {/* 2 colunas sofisticadas */}
        <div className="grid gap-8 md:grid-cols-2 items-start">
          {/* Marca + redes (sem bolacha) */}
          <div>
            <span className="text-lg font-extrabold">LOViZ Telecom</span>
            <p className="mt-2 text-sm text-white/70 max-w-sm">
              Conectividade e automação para condomínios — tudo em uma única infraestrutura.
            </p>

            <div className="mt-5 flex items-center gap-4 text-white/70">
              <a href="#" aria-label="Instagram" className="hover:text-white transition-colors"><IconInsta /></a>
              <a href="#" aria-label="LinkedIn" className="hover:text-white transition-colors"><IconLinkedIn /></a>
              <a href="#" aria-label="X / Twitter" className="hover:text-white transition-colors"><IconX /></a>
            </div>
          </div>

          {/* Cartão de contato — ícones sem fundo redondo */}
          <div >
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <IconMapPin className="h-5 w-5 text-white/80 mt-0.5" />
                <span className="text-white/80 leading-relaxed">{ADDRESS}</span>
              </li>
              <li className="flex items-center gap-3">
                <IconPhone className="h-5 w-5 text-white/80" />
                <a href={`tel:+${WHATS_E164}`} className="hover:text-white">{WHATS_HUMAN}</a>
              </li>
              <li className="flex items-center gap-3">
                <IconMail className="h-5 w-5 text-white/80" />
                <a href={`mailto:${EMAIL}`} className="hover:text-white">{EMAIL}</a>
              </li>
            </ul>

            <div className="mt-5">
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                className="sales-btn inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-semibold text-white whitespace-nowrap"
                aria-label={`Falar com vendas no WhatsApp: ${WHATS_HUMAN}`}
              >
                Falar com vendas
              </a>
            </div>
          </div>
        </div>

        {/* separador */}
        <div className="mt-8 h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />

        {/* barra inferior clean */}
        <div className="mt-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/60">
          <p>© {year} LOViZ Telecom. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4">
            <a href="/privacidade" className="hover:text-white">Privacidade</a>
            <a href="/termos" className="hover:text-white">Termos</a>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="inline-flex items-center gap-1 rounded-full bg-white/5 px-3 py-1.5 ring-1 ring-white/10 hover:ring-white/20"
              aria-label="Voltar ao topo"
            >
              <IconArrowUp /> Topo
            </button>
          </div>
        </div>
      </div>

      {/* botão com glow rosa suave */}
      <style>{`
        .sales-btn {
          background: linear-gradient(90deg, #FF0064 0%, #ff4d91 100%);
          box-shadow:
            0 10px 24px -14px rgba(255,0,100,.36),
            inset 0 0 0 1px rgba(255,255,255,.12);
          transition: box-shadow .2s ease, transform .15s ease;
          animation: salesPulse 4s ease-in-out infinite;
        }
        .sales-btn:hover {
          transform: translateY(-1px);
          box-shadow:
            0 18px 38px -16px rgba(255,0,100,.5),
            inset 0 0 0 1px rgba(255,255,255,.16);
        }
        @keyframes salesPulse {
          0%,100% { box-shadow: 0 10px 24px -14px rgba(255,0,100,.34), inset 0 0 0 1px rgba(255,255,255,.12); }
          50%      { box-shadow: 0 24px 50px -18px rgba(255,0,100,.52), inset 0 0 0 1px rgba(255,255,255,.18); }
        }
      `}</style>
    </footer>
  );
}
